import { Select, SelectOption } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Validations } from 'interfaces';
import { FormItemLayout } from 'antd/es/form/Form';

interface EnumProps {
  id: number;
  title: string;
}

interface CategorySelectProps extends Validations {
  name?: (string | number)[] | string | number;
  mode?: 'multiple' | 'tags';
  noStyle?: boolean;
  label?: string;
  disabled?: boolean;
  limited?: string[];
  layout?: FormItemLayout;
}

const CategorySelect = ({
  name,
  mode,
  validations,
  noStyle,
  label,
  disabled,
  limited,
  layout,
}: CategorySelectProps) => {

  const { data } = useQueryApiClient({
    request: {
      url: `api/v2/pages-category`,
    },
  });

  return (
    <Select
      mode={mode}
      label={label}
      name={name}
      validations={validations}
      noStyle={noStyle}
      disabled={disabled}
      layout={layout}
    >
      {data
        .filter((entry: EnumProps) =>
          limited?.length ? limited?.includes(entry.title) : true
        )
        .map((entry: EnumProps) => (
          <SelectOption key={entry.id} value={entry.id}>
            {entry.title}
          </SelectOption>
        ))}
    </Select>
  );
};

export default CategorySelect;
